// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue                  from 'vue'
import App                  from './App'
import VueRouter            from "vue-router"
import router               from './router'
import axios                from 'axios'
import VueTheMask           from 'vue-the-mask'
import VueMoney             from 'v-money'
import mobile               from 'mobile-device-detect';
// import Autocomplete         from '@trevoreyre/autocomplete-vue'
// import '@trevoreyre/autocomplete-vue/dist/style.css'
// import CKEditor from '@ckeditor/ckeditor5-vue2';
// import VueSuggestion        from 'vue-suggestion'

// import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

var url                     = "https://caveirinha.negociar.tech";
// var url                     = "http://localhost:8081";
// Vue.use(CKEditor)
Vue.use(VueRouter)
Vue.use(VueTheMask)
Vue.use(VueMoney)
Vue.use(mobile)
// Vue.use(Autocomplete)
// Vue.use(VueSuggestion)
window.axios                = axios
axios.defaults.baseURL      = url;
Vue.config.productionTip    = false
window._app;

if (!window.cordova && location.hostname != "localhost") {
    window.console.log      = function(){};
}
if (window.cordova || location.hostname != "localhost") {
    axios.defaults.timeout  = 35000;
}

/* eslint-disable no-new */
new Vue({
  	el:                  '#app',
  	router,
  	components: {
        App
    },
  	template:            '<App/>',

    data: {
        "titulo":       null,
        "backFn":       null,
        "logged":       false,
        "cordova":      window.cordova || null,
        "user":  {
            "_cod":     null,
            "_token":   null,
            "tipo":     null
        },
        "form":         null,
        "mobile":       mobile,
        "tmp":  {
            
        },
        "config": {
            "url":      url,
            "googleAnalytics": {
                "id":   ""
            },
            "pusher": {
                "key": ""
            },
            "money": {
                "decimal":            ',',
                "thousands":          '.',
                "prefix":             '',
                "suffix":             '',
                "precision":          2,
                "masked":             false
            }      
        }
    },
    methods: {
        initialize: function() {
            console.log("app.initialize()");
            var self = this;

            // gtag('js', new Date());
            // gtag('config', self.config.googleAnalytics.id);

            window.confirmWeb   = window.confirm;
            window.confirm      = function(msg, callback) {
                if (window.confirmWeb(msg)) {
                    callback();
                }
            }

            var self        = this;
            window.__app    = self;
            self.fixClass();

        },
        scrollTop: function() {
            console.log("scrollTop()")
            setTimeout(function() {
                $("body")[0].scrollTo({
                    top:            0
                });     
            }, 100);
        },          
        go: function(route, data) {
            console.log("app.go()", route, data)
            var self = this;

            if (!data) {
                data = {};
            } else {
                data = JSON.parse(data);
            }
            self.$router.push({ 
                name:       route,
                query:      data
            }).catch(()=>{});               
            $("body .overhang").fadeOut(500);
        },                
        back: function() {
            var self = this;
            console.log("back()", self, window.history.length);
            if (window.history.length > 3) {
                $(".content-load .dashboard-container").fadeOut(100);                
            }

            if (self.$route.meta.auth == false) {
                window.history.go(-3);
            } else {
                window.history.back();
            }

        },
        fixClass: function() {
            var self = this;
            if (self.$route) {
                $("body").attr("class", "");
                if (self.$route.name) {
                    $("body").addClass("current-page-" + self.$route.name.toLowerCase());  
                }
            }
        },
    },
    created: function() {
    	console.log("APP created")
    	var self = this;
        self.initialize();  
    	if (window.__usuario) {
    		self.setUser(window.__usuario);
    	}
    },
	watch:{
	    $route (to, from){
	        var self = this;
            self.fixClass();
	        setTimeout(function() {
                self.scrollTop();                
                // gtag('config', self.config.googleAnalytics.id, {'page_title': to.meta.title});                 

	        }, 100);
	    }, 
	},
    on: {
        
    }      	
})



// WEBPACK FOOTER //
// ./src/main.js